var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconControlBarLoginLike = function SvgIconControlBarLoginLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0589C9",
    fillRule: "evenodd",
    d: "M10.536 1.875c1.137-1.079 2.973.006 2.583 1.52v.002l-.72 2.766 3.336-.02c1.916-.022 3.216 1.941 2.45 3.697l-2.43 5.577a2.48 2.48 0 0 1-2.269 1.486H7.888c-.4 0-.778-.093-1.113-.259a.7.7 0 0 1-.275.056H3.2A1.7 1.7 0 0 1 1.5 15V8a1.7 1.7 0 0 1 1.7-1.7h2.677l.055-.055zM5.37 7.7H3.2a.3.3 0 0 0-.3.3v7a.3.3 0 0 0 .3.3h2.342a2.5 2.5 0 0 1-.172-.916zm6.511-4.146c.108-.49-.49-.815-.843-.46L6.896 7.26a.4.4 0 0 0-.125.291v6.833c0 .618.5 1.118 1.117 1.118h5.598c.427 0 .814-.253.986-.646L16.9 9.281a1.24 1.24 0 0 0-1.151-1.737h-.005l-4.12.02a.5.5 0 0 1-.491-.607z",
    clipRule: "evenodd"
  })));
};
export default SvgIconControlBarLoginLike;